import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  name: 'flows',
  namespaced: true,
  state,
  actions,
  mutations,
};
